import { RightWrapper } from "../../../components";
import { Button, DataTable } from "@/components";
import { useMemo, useEffect, useState } from "react";
import ColumnHelper from "@/utils/ColumnHelper";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLoginCredentials,
  selectLoginCredentialsById,
  selectCustomerById,
  fetchCustomerData,
} from "../../../app/Slices";
import { useAlert } from "@/";
import { useParams } from "react-router-dom";
const LoginCreditials = () => {
  const { id } = useParams();
  const { alert, AlertDialog } = useAlert();
  const dispatch = useDispatch();

  const [loginCreditials, setLoginCreditials] = useState([]);

  const fetchData = async (dispatch) => {
    try {
      const response = await dispatch(fetchLoginCredentials({ userId: id }));

      if (fetchLoginCredentials.fulfilled.match(response)) {
        // console.log("Login Credentials Fulfilled:", response);
        setLoginCreditials(response.payload || []);
      } else if (fetchLoginCredentials.rejected.match(response)) {
        alert(response.payload || []);
        // console.log("Login Credentials Rejected:", response);
      }
    } catch (error) {
      console.error("Error fetching login credentials:", error);
    }
  };

  useEffect(() => {
    fetchData(dispatch);
  }, [dispatch, id]);
  const isLoadingLoginCreditials = useSelector(
    (state) => state.loginCredentials.loading
  );
  const handleBlock = async () => {
    // await alert("Employee saved successfully", "success");
  };
  const clientColumns = useMemo(
    () => [
      ColumnHelper({
        header: "Client ID",
        accessorKey: "",
        cell: (info) => info.row.original.user?.clientId || "N/A",
        meta: {
          tooltip: (row) => row.user?.clientId || "N/A",
        },
      }),
      ColumnHelper({
        header: "Customer Name",
        accessorKey: "",
        cell: (info) => info.row.original.user?.name || "N/A",
        meta: {
          tooltip: (row) => row.user?.name || "N/A",
        },
      }),
      ColumnHelper({
        header: "Mail ID",
        accessorKey: "",
        cell: (info) => info.row.original.user?.email || "N/A",
        meta: {
          tooltip: (row) => row.user?.email || "N/A",
        },
      }),
      ColumnHelper({
        header: "Login Type",
        accessorKey: "",
        cell: (info) =>
          info.row.original.user?.isLoggedInByGoogle ? "Google" : "Email",
        meta: {
          tooltip: (row) =>
            row.isLoggedInByGoogle
              ? "Logged in via Google"
              : "Logged in via Email",
        },
      }),

      ColumnHelper({
        header: "Monthly Shipments",
        accessorKey: "",
        cell: (info) => info.row.original.user?.monthlyShipments || "N/A",
        meta: {
          tooltip: (row) => row.user?.monthlyShipments || "N/A",
        },
      }),
      ColumnHelper({
        header: "Actions",
        accessorKey: "id",
        cell: (info) => (
          <div className="flex gap-1 justify-start items-center">
            <Button size="xs" onClick={() => handleBlock(info.row.original.id)}>
              Block
            </Button>
          </div>
        ),
        meta: {
          tooltip: () => "Block this client",
        },
      }),
    ],
    []
  );

  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Employee Name",
        accessorKey: "name",
        meta: {
          tooltip: (row) => row.name || "N/A",
        },
      }),
      ColumnHelper({
        header: "Mobile",
        accessorKey: "phoneNumber",
        meta: {
          tooltip: (row) => row.phoneNumber,
        },
      }),
      ColumnHelper({
        header: "Mail ID",
        accessorKey: "email",
        meta: {
          tooltip: (row) => row.email || "N/A",
        },
      }),
      ColumnHelper({
        header: "Permission",
        accessorKey: "permissions",
        meta: {
          tooltip: (row) => row.permissions?.join(", ") || "N/A",
        },
        cell: (info) => info.row.original.permissions?.join(", ") || "N/A",
      }),
    ],
    []
  );
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 m-2 pb-20 md:pb-4">
        {/* Header Section */}
        <DataTable
          columns={clientColumns}
          tittle="Customer’s Credentials"
          data={[loginCreditials]}
          isLoading={isLoadingLoginCreditials}
          showCheckbox={false}
        />
        <DataTable
          columns={columns}
          tittle="Customer’s Employees Credentials"
          data={loginCreditials?.customersEmployees || []}
          isLoading={isLoadingLoginCreditials}
          showCheckbox={false}
        />
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default LoginCreditials;
